import { Grid, Theme, Typography, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import { get as _get } from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getUserData } from '../../../app/store/combinedSelectors';
import { checkAndReplaceDummyPhoneNumber } from '../../../utils/Utilities';
import EmailInput from '../../shared/EmailInput/EmailInput';
import PhoneInput from '../../shared/PhoneInput/PhoneInput';
export interface ContactInfoProps {
  header: string;
  description: string;
  styleInfo: ContactStyleInfo;
  prefilledContactTypeInfo: {
    phoneNumber: string;
    emailAddress: string;
  };
  selectionChangeHandler: (formOptions: any) => void;
}

export interface ContactStyleInfo {
  headerStyle: {
    fontFamily: string;
    fontWeight: number;
    fontSize: number;
    color: string;
    lineHeight: string;
  };
  descriptionStyle: {
    fontFamily: string;
    fontWeight: number;
    fontSize: number;
    color: string;
    lineHeight: string;
  };
}

export default function ContactInfo(props: ContactInfoProps) {
  let customerData = useSelector(getUserData);

  // Grab phone number and email if insured contact type is already answered
  if (
    _get(props, 'prefilledContactTypeInfo.emailAddress', '') &&
    _get(props, 'prefilledContactTypeInfo.phoneNumber', '')
  ) {
    customerData = props.prefilledContactTypeInfo;
  }

  const theme: Theme = useTheme();
  const [email, setEmail] = useState(customerData.emailAddress);
  const [isEmailValid, setIsEmailValid] = useState(!!customerData.emailAddress);
  const [phone, setPhone] = useState(checkAndReplaceDummyPhoneNumber(customerData.phoneNumber));
  const [isPhoneValid, setIsPhoneValid] = useState(!!checkAndReplaceDummyPhoneNumber(customerData.phoneNumber));

  useEffect(() => {
    props.selectionChangeHandler({
      phone: phone,
      isPhoneValid: isPhoneValid,
      email: email,
      isEmailValid: isEmailValid,
    });
  }, [phone, isPhoneValid, email, isEmailValid]);

  function emailChange(event: string) {
    setEmail(event);
  }

  function emailValid(event: boolean) {
    setIsEmailValid(event);
  }

  function phoneChange(event: string) {
    setPhone(event);
  }

  function phoneValid(event: boolean) {
    setIsPhoneValid(event);
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Typography gutterBottom sx={{ ...props.styleInfo.headerStyle, marginBottom: '1.5rem' }}>
        {props.header}
      </Typography>
      <Typography sx={{ ...props.styleInfo.descriptionStyle, marginBottom: '1.5rem' }} gutterBottom>
        {props.description}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <PhoneInput
            isRequired={true}
            hideSubCase={false}
            phoneValid={phoneValid}
            defaultValue={checkAndReplaceDummyPhoneNumber(customerData.phoneNumber)}
            phoneValueUpdate={phoneChange}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <EmailInput
            isRequired={true}
            hideSubCase={false}
            emailValid={emailValid}
            defaultValue={customerData.emailAddress}
            emailValueUpdate={emailChange}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
